<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="fechaDesdeParam"
          :fechaHasta="fechaHastaParam"
          :chequesPendientes="chequesPendientes"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
          <b-card header="Listado de Cheques Propios Emitidos">
            <b-table hover
                responsive="sm" 
                class="registro"
                :busy="tableBusy"
                :items="cartera" 
                :fields="fields" 
                @row-clicked="consultar">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>              
              <template v-slot:cell(fechaPago)="data">
                {{ data.item.fechaPago | fecha }}
              </template>
              <template v-slot:cell(fechaCreditoDebito)="data">
                {{ data.item.fechaCreditoDebito | fecha }}
              </template>
              <template v-slot:cell(numero)="data">
                {{ data.item.numero }}
              </template>
              <template v-slot:cell(importe)="data">
                {{ data.item.importe | moneda }}
              </template>
              <template v-slot:cell(conciliado)="data">
                {{ data.item.conciliado ? 'Si' : 'No' }}
              </template>
            </b-table>
            <nav>
              <b-pagination size="sm" 
                :total-rows="totalRegistros" 
                :per-page="registrosPorPagina" 
                v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
            </nav>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item
              @click.stop="exportCarteraXls">
            <i class="fa fa-file-excel-o"></i>Exportar Cartera de Cheques</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import Filtro from './chequesPropiosFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'chequespropios/getField',
  mutationType: 'chequespropios/updateField',
});

export default {
  name: 'CarteraChequesPropios',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      fields: [
        { 
          key: 'fechaPago',
          label: 'Fecha Pago'
        },
        { 
          key: 'fechaCreditoDebito',
          label: 'Fecha Ingreso'
        },
        { 
          key: 'bancoCuenta',
          label: 'Cuenta'
        },
        { key: 'proveedor' },
        // { 
        //   key: 'bancoMovimientoTipo', 
        //   label: 'Tipo de Movimiento'
        // },
        {
          key: 'numero',
          class: 'text-right',
        },
        {
          key: 'importe',
          class: 'text-right',
        },
        {
          key: 'conciliado',
          class:'text-center'
        },

        // {
        //   key: 'opciones',
        //   label: '',
        //   class:'text-center'
        // },
      ],

      tableBusy: false,
      loaded: false,

      // chequeSeleccionadoId: 0,
    }
  },
  computed: {
    ...mapFields([
      'cartera',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'chequesPendientes',
      'chequesPendientesTodos'
    ]),
    fechaDesdeParam() {
      return moment(this.fechaDesde).format('YYYY-MM-DD');
    },
    fechaHastaParam() {
      return moment(this.fechaHasta).format('YYYY-MM-DD');
    }
  },
  created() {
    this.getCartera();
  },  
  methods: {
    getCartera() {
      this.tableBusy = true;
      this.$store.dispatch('chequespropios/getCartera')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },    
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.chequesPendientes = filtro.chequesPendientes;
      this.chequesPendientesTodos = filtro.chequesPendientesTodos;
      this.paginaActual = 1;
      
      this.getCartera();
    },
    consultar (item) {
      this.$router.push({ name: 'ChequePropioData', 
                          params: { id: item.id }})
    },
    exportCarteraXls () {
      this.showSpinner();
      this.$store.dispatch('chequespropios/getRptCartera')
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptChequesPropios = this.$store.getters['chequespropios/rptChequesPropios'];

          if (rptChequesPropios) {
            if (rptChequesPropios.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            let title= 'Listado de Cheques';
            let fileName = 'cheques-propios';

            let format = [
              { titulo: 'Fecha Emisión', nombre: 'fechaEmision', formato: 'fecha' },
              { titulo: 'Fecha Pago', nombre: 'fechaPago', formato: 'fecha' },
              { titulo: 'Fecha Ingreso', nombre: 'fechaCreditoDebito', formato: 'fecha' },
              { titulo: 'Cuenta', nombre: 'bancoCuenta', formato: '' },
              { titulo: 'Proveedor', nombre: 'proveedor', formato: '' },
              { titulo: 'Número', nombre: 'numero', formato: '' },
              { titulo: 'Importe', nombre: 'importe', formato: 'moneda' },
              { titulo: 'Conciliado', nombre: 'conciliado', formato: 'bool' }
            ];

            this.exportXLS(title, fileName, rptChequesPropios, format);
          } else {
            this.showModalMsj('No hay datos para exportar', null, null, 'light')
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getCartera(); 
      }
    },    
  }    
}
</script>

<style>
</style>
